import { t } from "i18next";
import * as z from "zod";

import { compactIdentifier } from "@/core/utils/func/input-normalization";
import {
  PAYOUT_METHODS,
  SETTLEMENT_FREQUENCIES,
} from "@/features/shared/api/enums";

/**
 * Schéma du formulaire de configuration de reversement
 * (`PUT /MerchantSettlementConfigs/merchant/{merchantId}`). Le compte
 * bancaire n'est requis que si `payoutMethod === "BANK_ACCOUNT"`.
 */
export const createSettlementConfigSchema = () =>
  z
    .object({
      merchantId: z
        .string()
        .trim()
        .min(1, { message: t("requiredFieldError") }),
      frequency: z.enum(SETTLEMENT_FREQUENCIES, {
        errorMap: () => ({ message: t("requiredFieldError") }),
      }),
      payoutMethod: z.enum(PAYOUT_METHODS, {
        errorMap: () => ({ message: t("requiredFieldError") }),
      }),
      bankAccount: z
        .string()
        .transform((raw) => {
          const trimmed = raw.trim();
          return trimmed ? compactIdentifier(trimmed) : "";
        })
        .optional(),
    })
    .superRefine((values, ctx) => {
      if (
        values.payoutMethod === "BANK_ACCOUNT" &&
        !values.bankAccount?.trim()
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["bankAccount"],
          message: t("requiredFieldError"),
        });
      }
    });

export type SettlementConfigFormValues = z.infer<
  ReturnType<typeof createSettlementConfigSchema>
>;
